<div
  stack-layout
  [fullHeight]="true"
  paddingHorizontal="lg"
  paddingTop="sm"
  paddingBottom="md"
>
  @if (breadcrumb()) {
    <div row-layout alignItems="center" gap="xs">
      <a [routerLink]="breadcrumbLink() || '/'">
        <Text color="primary">{{ breadcrumb() }}</Text>
      </a>
      <Symbol name="chevron_right" />
      <Text color="on-background-variant">{{ headline() }}</Text>
    </div>
  }
  <div
    row-layout
    alignItems="center"
    [height]="56"
    [paddingLeft]="headlinePaddingLeft()"
  >
    <Text role="headline-large" color="on-background-variant" display="block"
      >{{headline()}}</Text
    >
  </div>
  <div box-layout [grow]="1">
    <ng-content></ng-content>
  </div>
</div>
